import React from 'react';
import styles from '../css/Nav.module.css';
import { Link, NavLink } from "react-router-dom";
import logo from 'asset/images/logo.png';
import { MuseumOutlined, MicExternalOnOutlined, GraphicEq, AccountCircle, AdminPanelSettings, Person } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { useDispatch, useSelector } from "react-redux";
import { commonActions } from "../../reducers/common";

const drawerWidth = 250;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);


const AsideNav = () => {
    const dispatch = useDispatch();
    const drawerOpen = useSelector(state => state.commonData.drawerOpen);
    const user = useSelector(state => state.commonData.user);

    const handleDrawerClose = () => {
        dispatch(commonActions.handleDrawerClose())
    }
    const handleDrawerOpen = () => {
        dispatch(commonActions.handleDrawerOpen())
    }

    return (
        <Box sx={{ display: 'flex', background: '#231f1f' }} className={styles.asideContainer}>
            <Drawer variant="permanent" open={drawerOpen}>
                <DrawerHeader className={styles.asideHeader}>
                    {drawerOpen && <h1><Link to={"/setting/exhibition"}><img alt={"logo"} src={logo} /></Link></h1>}
                    <IconButton onClick={drawerOpen ? handleDrawerClose : handleDrawerOpen}>
                        {!drawerOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                {drawerOpen &&
                    <>
                    <div className={styles.asideRole}>
                        <h4>{user?.role.name === 'owner' ? < AdminPanelSettings /> : <Person />} {user?.role.category}</h4>
                        <h5><span>ID:</span> {user?.username}</h5>
                    </div>
                    </>
                }
                <Divider />
                <ul className={`asideGnb ${styles.asideGnb}`}>
                    {['전시 관리', '오디오 관리', '해설자 관리', '계정 관리'].map((text, index) => (
                        <ListItem key={text} disablePadding sx={{ display: 'block', padding: '0 !important' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: drawerOpen ? 'initial' : 'center',
                                    padding: 0,
                                }}
                            >
                                <NavLink to={
                                    index === 0 ? "/setting/exhibition"
                                    : index === 1 ? "/setting/audio"
                                        : index === 2 ? "/setting/commentator"
                                            : index === 3 ? "/setting/account" : null
                                }>
                                    {index === 0 ? <MuseumOutlined />
                                        : index === 1 ? <GraphicEq />
                                        : index === 2 ? <MicExternalOnOutlined />
                                            : index === 3 ? <AccountCircle /> : null
                                    }
                                    <p style={{display: drawerOpen ? 'inline-block' : 'none'}}>{text}</p>
                                </NavLink>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </ul>
            </Drawer>
        </Box>
    );
};

export default AsideNav;